import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(({ spacing }) => ({
  container: {
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    paddingTop: 0,
    paddingBottom: 0
  },
  title: {
    marginRight: spacing(1),
    fontWeight: 500
  },
  card: {
    border: 'solid',
    borderWidth: 1,
    borderColor: '#D7D7D7',
    borderRadius: 5,
    marginBottom: spacing(2),
    backgroundColor: '#FCFCFC'
  },
  list: {
    marginBottom: 8
  },
  containerMargin: {
    marginTop: 0,
    marginBottom: 0,
    paddingTop: 0,
    paddingBottom: 0
  },
  warningBox: {
    width: '100%',
    margin: spacing(1),
    backgroundColor: '#fcd40a',
    borderRadius: 10
  },
  warningBoxTypography: {
    color: '#1E5168',
    fontWeight: 'bold',
    padding: 10
  }
}));